import { GetBookOrderResponse, INLegTotalPrice } from "./nLegsInterfaces";
import { OrderStatus } from "./orderInterfaces";
import { StepOptionOrderType, StepOrderSide } from "./stepInterfaces";
import { ITableReport } from "./TableInterfaces";

export enum DeltaHedgeOrderType {
  Open = 1,
  Offset = 2,
  Roll = 3,
}

export interface IDeltaHedgeOrderTablesSearchParam {
  deltaHedgeOrderType: DeltaHedgeOrderType;
  instrumentId: number;
  accountId: number;
}

export interface IDeltaHedgeAggregationTablesSearchParam {
  deltaHedgeOrderType: DeltaHedgeOrderType;
  instrumentId: number;
  accountId: number;
}

export interface IDeltaHedgeOrderFormValues {
  accessMessage?: string;
  accountName?: string;
  userName?: string;
  instrumentNames?: string[];
  instrumentName1?: string;
  instrumentName2?: string;
  originalVolumeInput?: number | null;
  portfoPercent?: number | null;
  involvedFund?: number | string | null;
  sheet?: string;
  row?: number;
  accountId: number;
  deltaHedgeOrderType: DeltaHedgeOrderType;
  orderSide1: StepOrderSide;
  orderSide2: StepOrderSide;
  instrumentId1: string;
  optionOrderType1: StepOptionOrderType;
  instrumentId2: string;
  optionOrderType2: StepOptionOrderType;
  baseVolumeSide: StepOrderSide;
  baseVolume: number;
  lockProfitTarget: number;
  blockSize: number;
  marginInPercent: number;
}

export interface IDeltaHedgeOrderEditValues {
  applyToSimilar: boolean;
  lockProfitTarget: number;
  id: number;
  process: string;
  conditionId?: number;
}

export interface IDeltaHedgeOrderTableReport extends ITableReport {
  algorithm_order_id: number;
  condition_id: number;
  process: string;
  isActive: boolean;
  orderStatus: OrderStatus;
  account: string;
  accountId: number;
  instrumentIds: string[];
  orderSideStr: string;
  instrumentName: string;
  optionOrderType1: StepOptionOrderType;
  optionOrderType2: StepOptionOrderType;
  deltaHedgeOrderType: string;
  offsetOpenStatus: string;
  baseSide: number;
  baseVolume: number;
  done: string;
  pending: string;
  exePrice: string;
  targetPercent: number;
  blockPercent: number;
  marginPercent: number;
  errorCount: number;
  dateStr: string;
  date: string;
  orderSide1: StepOrderSide;
  orderSide2: StepOrderSide;
}

export interface IBulkOrderRow extends ITableReport {
  accountId: number;
  sheet: string;
}

export interface IDeltaHedgeOrderbookParams {
  ins1: string;
  ins2: string;
  orderSide1: StepOrderSide;
  orderSide2: StepOrderSide;
}

export interface IDeltaHedgeOrderbookInfo {
  dailyLockProfitPercent: number;
  dailyLockProfitPercentOffset: number;
}

export interface IDeltaHedgeOrderbookResp {
  orderBooks: GetBookOrderResponse[];
  totalPrices: INLegTotalPrice[];
  info: IDeltaHedgeOrderbookInfo;
}

export interface IDeleteOMSOrder {
  minTimeInMinutes: string;
  minDistanceFromTopPrice: number;
  minDistanceFromTopPricePercent: number;
}

export interface IUpdateDeltaHedgeTargetDto {
  instrumentId1: string;
  instrumentId2: string;
  orderSide1: StepOrderSide;
  orderSide2: StepOrderSide;
  optionOrderType1: StepOptionOrderType;
  optionOrderType2: StepOptionOrderType;
  deltaHedgeOrderType: DeltaHedgeOrderType;
  newLockProfitTarget: number;
}
